import LegalPage from "./LegalPage";
export default function Earnings() {
  return (
    <div data-testid="earnings-page"><LegalPage eyebrow="Disclaimer" title="Earnings Disclaimer">
      <p>Bounce City University provides education, mentorship, systems, templates, training and support.</p>
      <p>It does not guarantee specific income, revenue, profit, bookings, funding, business growth or business success.</p>
      <p>Financial examples, projections, calculators, testimonials and case studies are educational examples and not promises.</p>
      <p>Results vary based on effort, execution, experience, market, location, competition, capital, pricing, demand and business decisions.</p>
    </LegalPage></div>
  );
}
